// extracted by mini-css-extract-plugin
export var endGameContainer = "EndGame-module--endGameContainer--3CcLS";
export var gameEndTitle = "EndGame-module--gameEndTitle--3csLB";
export var restartButton = "EndGame-module--restartButton--4frO0";
export var homeButton = "EndGame-module--homeButton--3K9Ub";